import React from 'react'
import { CenterPanel } from 'view/routes/routesLayout'
import { FxRateHeroPanel } from './FxRateHeroPanel'
import { FxRateGrid } from './FxRateGrid'
import { Permission } from 'api'
import { Permissioned } from 'view/shell/Permissioned'

export const FxRateScreen: React.FC = () => (
  <Permissioned oneOf={[Permission.FX_RATE_MANAGE, Permission.FX_RATE_VIEW]}>
    <CenterPanel>
      <FxRateHeroPanel />
      <FxRateGrid />
    </CenterPanel>
  </Permissioned>
)
